<template>
<div class=""  style="padding:0 20px;">

  <el-form ref="formBasic" :model="$abstract.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

   <div class="title_h1 yo-color-primary">E-POSTER</div>
   <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;">» {{$abstract.profile.row.titolo}}</div>



<br /><br />
         

   <div class="row " style="margin-top:20px;">
 

      <div class="col s12 m6 clear">
         <div class="col s4"><label for="eposter" class="el-form-item__label" style="width:100% !important">Document (pdf)</label></div>
         <upload class="col s8" 
         :value="$abstract.profile.row.eposter" 
         v-on:change="val => $abstract.profile.row.eposter=val" 
         v-on:success="eposterSuccess" 
         action="https://api.mzevents.it/201806/vue/upload/" 
         :savedir="'/www/esphm.mzevents.it/efile/'+$evento.profile.row.id+'/eposter/'" 
         :previewurl="'https://esphm.mzevents.it/efile/'+$evento.profile.row.id+'/eposter/'"
         :filename="$abstract.profile.row.id"
         extensions="pdf,PDF"></upload>
      </div>

   </div>
  <div class="row " style="margin-top:20px;">



   <div class="yo-text-l yo-text-bold yo-color-success">TECHNICAL NOTES</div>

<ul>
  <li>Please name your file as follows: {{$abstract.profile.row.codaffissione}}</li>
  <li>Only pdf formats are allowed.</li>
  <li>File size: 50 MB max.</li>
  <li>If you have an Oral Presentation and you want to show videos we suggest that you embed them in a ppt presentation or publish in your slides the link of the website where the video is published.</li>
  <li>E-poster should be in portrait</li>
  <!--
    -->
</ul>
<br />
<div class="yo-text-l yo-text-bold yo-color-danger-tolto">IMPORTANT INFORMATION</div>

<ul>
  <li class="yo-color-danger-tolto">All presentations and e-posters will be published online on our <a href="https://www.esphm.org/" target="_blank">Conference Platform</a> and only registered attendees will be able to access them.</li>
  <li class="yo-color-danger-tolto">You will have the chance to replace an already submitted presentation until <b>May 6, 2025.</b><br />
After that the latest version uploaded will be considered final and it will not be possible to make any further amendments.</li>

<!--  
<li class="yo-color-danger-tolto">Kindly note that in case of Oral Presentation or Flash Poster Presentation your uploaded work will be passed on directly to the slide center at the Venue, you will have the chance to display the presentation onsite at the slide center in case of need.</li>
<li class="yo-color-danger-tolto">You will have the chance to replace an already submitted e-poster / presentation until <strong>26<sup>th</sup> March 2021</strong>, after that the lastest version uploaded will be considered the final one.</li>
-->

</ul>

   </div>  

    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2" >
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Save</el-button>
      </div>
    </div>


    </el-form>



   
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
import upload from './Upload.vue'
export default {
  name: 'abstract-eposter',
  components: {
      upload
  },
  data() {
    return {

    }
  },
  created () {
    console.log("Arrivo al abstract-eposter.vue con id "+this.$abstract.profile.row.id)
  },
  beforeDestroy () {

  },
  methods: {
    eposterSuccess() {
      //this.doUpdate()
      this.$notify.success({type: 'info',message: 'Upload completed successfully', duration:5000})    
        
    },
    onCancel() {
      this.$router.push('/home/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {  
         this.Save()
        } else {
          this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
          return false;
        }
      });
    },
    async Save(){
      await this.$abstract.profile.save() 
      await this.$contatto.getAbstract() 
      console.log(this.$contatto._abstract)
      this.$router.push('/home/')      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>